<script lang="ts">
export const elTextCellStyles = ['normal', 'medium', 'underline'] as const;
export type ElTextCellStyle = (typeof elTextCellStyles)[number];

export const elTextCellColors = ['neutral', 'orange', 'error'] as const;
export type ElTextCellColor = (typeof elTextCellColors)[number];

export const getTextColorClass = (color?: ElTextCellColor, style?: ElTextCellStyle) => {
  if (style === 'underline') return 'text-brandBlue-500';
  if (color) {
    if (color === 'orange') return 'text-orange-500';
    if (color === 'error') return 'text-error-active';
  }
  return 'text-neutral-darker';
};
</script>

<script setup lang="ts">
import ElTooltip from './ElTooltip.vue';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    label: string;
    style?: ElTextCellStyle;
    colorText?: ElTextCellColor;
  }>(),
  {
    style: 'normal',
    colorText: undefined,
  },
);

const textColorClass = computed((): string => getTextColorClass(props.colorText, props.style));
</script>

<template>
  <ElTooltip :title="label.length > 20 ? label : ''">
    <div
      :class="[
        'text-sm overflow-hidden text-ellipsis',
        style === 'normal' && 'font-normal',
        style === 'medium' && 'font-medium',
        style === 'underline' && 'font-semibold underline',
        textColorClass,
      ]"
    >
      {{ label }}
    </div>
  </ElTooltip>
</template>
